import * as entity from '@common/domain/entities/RoleJob'
export class RoleJobEndPoints extends entity.RoleJobEndPoints {}

export class RoleJobFormFields extends entity.RoleJobFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class RoleJobForm extends entity.RoleJobForm {
  protected roleJobFormEndPoints: RoleJobEndPoints = new RoleJobEndPoints();
  protected roleJobFormFields: RoleJobFormFields = new RoleJobFormFields();
}

export class RoleJobListColumns extends entity.RoleJobListColumns {
  constructor() {
    super();
	    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class RoleJobList extends entity.RoleJobList {
  protected roleJobListEndPoints: RoleJobEndPoints = new RoleJobEndPoints();
  protected roleJobListColumns: RoleJobListColumns = new RoleJobListColumns();
}
//export class RoleJobGeneratedForm extends entity.RoleJobGeneratedForm {
  //protected detailPageComponentForm: RoleJobForm = new RoleJobForm();
//};

//export class RoleJobListPageComponent extends entity.RoleJobListPageComponent {
  //protected listPageComponentList: RoleJobList = new RoleJobList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RoleJobBlade extends entity.RoleJobBlade {};
//export class RoleJobListBlade extends entity.RoleJobListBlade {};

